"use client";

import Image from "next/image";
import { type ServiceContent } from "../data/types";
import { ServiceContentComponent } from "../components/ServiceContent";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface DescriptionFirstProps {
  imagePath: string;
  title: string;
  content: ServiceContent[];
}

export const DescriptionFirst = ({
  imagePath,
  title,
  content,
}: DescriptionFirstProps) => {
  const pathname = usePathname();
  const isColorationVegetale = pathname === "/prestations/coloration-vegetale";
  const isPrivatisation = pathname === "/prestations/privatisation-lieu";
  const isHeadSpa = pathname === "/head-spa";
  const planityVilleDAvrayUrl =
    "https://www.planity.com/alexandra-grey-92410-ville-davray";
  const planityHeadSpaUrl =
    "https://www.planity.com/au-grey-des-couleurs-94800-villejuif";

  return (
    <div className="flex flex-col gap-8 px-4 pb-20 pt-8 ph:px-24 md:flex-row md:px-48 lg:px-72 xl:px-96">
      <div className="relative aspect-[804/804] w-full md:w-1/2">
        <Image
          src={imagePath}
          alt={title}
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          className="object-cover"
        />
      </div>

      <div className="space-y-8 md:w-1/2">
        <h1 className="text-2xl uppercase text-primary">{title}</h1>
        <div className="flex flex-col gap-4">
          {content.map((item, index) => (
            <ServiceContentComponent key={index} content={item} />
          ))}
        </div>
        <div className="flex flex-col gap-4">
          {isColorationVegetale ? (
            <Link
              href={planityVilleDAvrayUrl}
              className="group relative inline-block w-fit pb-[2px]"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Réserver à Ville d&apos;Avray</span>
              <div className="absolute bottom-0 left-0 h-[1px] w-full bg-black">
                <div className="h-full w-0 bg-gold transition-all duration-300 ease-out group-hover:w-full" />
              </div>
            </Link>
          ) : isPrivatisation ? (
            <Link
              href="#privatisation-form"
              className="group relative inline-block w-fit pb-[2px]"
            >
              <span>Remplir le formulaire de privatisation</span>
              <div className="absolute bottom-0 left-0 h-[1px] w-full bg-black">
                <div className="h-full w-0 bg-gold transition-all duration-300 ease-out group-hover:w-full" />
              </div>
            </Link>
          ) : isHeadSpa ? (
            <Link
              href={planityHeadSpaUrl}
              className="group relative inline-block w-fit pb-[2px]"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Réserver un soin Head Spa</span>
              <div className="absolute bottom-0 left-0 h-[1px] w-full bg-black">
                <div className="h-full w-0 bg-gold transition-all duration-300 ease-out group-hover:w-full" />
              </div>
            </Link>
          ) : (
            <Link
              href="/reservation"
              className="group relative inline-block w-fit pb-[2px]"
            >
              <span>Réserver dans un salon</span>
              <div className="absolute bottom-0 left-0 h-[1px] w-full bg-black">
                <div className="h-full w-0 bg-gold transition-all duration-300 ease-out group-hover:w-full" />
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
